(() => {
  const dialog = document.getElementById('zenx-email-draw-dialog');
  const trigger = document.querySelector('.zenx-offer-tab');
  if (!dialog || !dialog.showModal || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const controller = new AbortController();
  const options = { signal: controller.signal };
  const preview = new URLSearchParams(location.search).get('zenx_welcome_preview') === '1';
  const hero = document.querySelector('[data-product-hero]');
  let previousFocus = null;
  let observer;
  let timer;
  const open = () => {
    const anotherDialog = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')]
      .some(element => {
        const rect = element.getBoundingClientRect();
        return element !== dialog && rect.width > 100 && rect.height > 100;
      });
    if (dialog.open || anotherDialog) return;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.documentElement.setAttribute('data-zen-signup-open', '');
    trigger?.setAttribute('aria-expanded', 'true');
    dialog.querySelector('.zenx-draw__close')?.focus({ preventScroll: true });
  };
  trigger?.addEventListener('click', open, options);
  dialog.querySelector('.zenx-draw__close')?.addEventListener('click', () => dialog.close(), options);
  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  }, options);
  dialog.addEventListener('close', () => {
    document.documentElement.removeAttribute('data-zen-signup-open');
    trigger?.setAttribute('aria-expanded', 'false');
    previousFocus?.focus?.({ preventScroll: true });
  }, options);
  if (trigger) {
    if (hero && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(([entry]) => {
        trigger.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      observer.observe(hero);
    } else {
      trigger.hidden = false;
    }
  }
  if (preview || dialog.querySelector('.zenx-draw__success, .zenx-draw__error')) timer = window.setTimeout(open, 150);
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.contains(dialog)) return;
    if (dialog.open) dialog.close();
    observer?.disconnect();
    window.clearTimeout(timer);
    controller.abort();
    delete dialog.dataset.initialized;
  }, options);
})();
